import { Bookmark, ClipboardList, CheckCircle, PartyPopper } from "lucide-react";

export const UnifiedStatusBadge = ({ status }) => {
  if (!status) return null;
  const cfg = {
    saved:     { icon: Bookmark,      label: "Saved",      bg: "bg-slate-100", text: "text-slate-600" },
    in_plan:   { icon: ClipboardList, label: "In Plan",    bg: "bg-sky-100",   text: "text-sky-700" },
    signed_up: { icon: CheckCircle,   label: "Signed Up",  bg: "bg-indigo-100", text: "text-indigo-700" },
    claimed:   { icon: PartyPopper,   label: "Claimed",    bg: "bg-emerald-100", text: "text-emerald-700" },
  }[status];
  if (!cfg) return null;
  const Icon = cfg.icon;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium ${cfg.bg} ${cfg.text}`} data-testid={`status-badge-${status}`}>
      <Icon className="w-3 h-3" />{cfg.label}
    </span>
  );
};
